export default __webpack_public_path__ + "static/media/logo-csmile.0bf2ae4d.png";